import { useEffect, useRef } from 'react'
import { motion } from 'framer-motion'
import './Intro.scss'
import { init } from 'ityped'

export default function Intro() {
  const textRef = useRef()

  useEffect(() => {
    init(textRef.current, {
      showCursor: false,
      backDelay: 1500,
      backSpeed: 50,
      strings: ['an Executive'],
    })
  }, [])

  return (
    <div className='intro' id='intro'>
      <motion.div
        whileInView={{ x: [-100, 0], opacity: [0, 1] }}
        transition={{ duration: 1 }}
        className='left'
      >
        <div className='imgContainer'>
          <img src='Assets/profilePic.png' alt='' />
        </div>
      </motion.div>
      <motion.div
        whileInView={{ opacity: [0, 1] }}
        transition={{ duration: 1.5, delayChildren: 0.5 }}
        className='right'
      >
        <div className='wrapper'>
          <h2>Hi There, I'm</h2>
          <h1>Asaduzzaman Riyad</h1>
          <h3>
            I am <span ref={textRef}></span>
          </h3>
        </div>
        <a href='#about'>
          <img src='Assets/down.png' alt='' />
        </a>
      </motion.div>
    </div>
  )
}
